var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 5C0 4.44772 0.447715 4 1 4H9C9.55229 4 10 4.44772 10 5C10 5.55228 9.55229 6 9 6H1C0.447715 6 0 5.55228 0 5Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5 10C4.44772 10 4 9.55228 4 9L4 1C4 0.447715 4.44772 0 5 0C5.55228 0 6 0.447715 6 1V9C6 9.55228 5.55228 10 5 10Z","fill":"currentColor","key":1})]);
}

PlusInline.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
